{
  "name": "ikp-frontends",
  "version": "berater-v1.14.1-rc1",
  "engines": {
    "pnpm": ">=10.0.0",
    "node": ">=20.19.0"
  },
  "projects": {
    "ikp": "apps/ikp",
    "ikp-berater": "apps/ikp-berater"
  },
  "scripts": {
    "ng": "nx",
    "reset": "nx reset",
    "start": "nx serve",
    "start:expose-host": "nx serve --host 0.0.0.0",
    "ikp": "pnpm nx run ikp:serve:local",
    "berater": "pnpm nx run ikp-berater:serve:local",
    "build": "pnpm nx build",
    "test": "pnpm nx run-many --target=test --all",
    "analyze": "ng build --prod --stats-json && webpack-bundle-analyzer dist/ikp/stats.json",
    "full-test": "pnpm run test && pnpm nx run-many --target=e2e --all",
    "prepare": "husky",
    "parse-version": "node parse-version.js"
  },
  "private": true,
  "dependencies": {
    "@aarsteinmedia/dotlottie-player": "^6.3.0",
    "@angular-architects/ngrx-toolkit": "^21.0.1",
    "@angular/animations": "21.2.6",
    "@angular/cdk": "21.2.0",
    "@angular/common": "21.2.6",
    "@angular/compiler": "21.2.6",
    "@angular/core": "21.2.6",
    "@angular/forms": "21.2.6",
    "@angular/localize": "21.2.6",
    "@angular/platform-browser": "21.2.6",
    "@angular/platform-browser-dynamic": "21.2.6",
    "@angular/router": "21.2.6",
    "@angular/service-worker": "21.2.6",
    "@azure/msal-angular": "^5.1.0",
    "@azure/msal-browser": "^5.3.0",
    "@editorjs/editorjs": "^2.31.3",
    "@editorjs/list": "^2.0.9",
    "@editorjs/paragraph": "^2.11.7",
    "@fortawesome/fontawesome-free": "6.7.2",
    "@fortawesome/fontawesome-pro": "6.7.2",
    "@fortawesome/fontawesome-svg-core": "6.7.2",
    "@fortawesome/free-solid-svg-icons": "6.7.2",
    "@ng-bootstrap/ng-bootstrap": "20.0.0",
    "@ng-doc/app": "21.0.0",
    "@ng-doc/builder": "21.0.0",
    "@ng-doc/core": "21.0.0",
    "@ng-doc/ui-kit": "21.0.0",
    "@ngrx/operators": "^20.1.0",
    "@ngrx/signals": "21.0.1",
    "@ngx-translate/core": "17.0.0",
    "@ngx-translate/http-loader": "17.0.0",
    "@piwikpro/ngx-piwik-pro": "^2.5.0",
    "@popperjs/core": "^2.11.8",
    "@tanstack/angular-table": "^8.21.3",
    "angular-oauth2-oidc": "^20.0.2",
    "bootstrap": "^5.3.8",
    "buffer": "^6.0.3",
    "chart.js": "^4.5.1",
    "chartjs-plugin-annotation": "^3.1.0",
    "data-forge": "^1.10.4",
    "dayjs": "^1.11.19",
    "editorjs-drag-drop": "^1.1.16",
    "editorjs-header-with-anchor": "^2.6.0",
    "js-cookie": "^3.0.5",
    "jsoneditor": "^10.4.2",
    "keycloak-angular": "^20.1.0",
    "keycloak-js": "^26.2.2",
    "ngx-webstorage": "20.0.0",
    "my-ua-parser": "^2.0.4",
    "ng2-charts": "^9.0.0",
    "qrious": "^4.0.2",
    "rxjs": "7.8.2",
    "short-unique-id": "^5.3.2",
    "swiper": "^12.1.2",
    "tslib": "^2.8.1",
    "valibot": "^1.2.0",
    "zone.js": "0.16.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "21.2.0",
    "@angular-devkit/core": "21.2.0",
    "@angular-devkit/schematics": "21.2.0",
    "@angular-eslint/builder": "21.2.0",
    "@angular-eslint/eslint-plugin": "21.2.0",
    "@angular-eslint/eslint-plugin-template": "21.2.0",
    "@angular-eslint/schematics": "21.2.0",
    "@angular-eslint/template-parser": "21.2.0",
    "@angular-eslint/utils": "21.2.0",
    "@angular/cli": "21.2.0",
    "@angular/compiler-cli": "21.2.6",
    "@angular/language-service": "21.2.6",
    "@eslint/eslintrc": "^3.3.4",
    "@eslint/js": "~10.0.1",
    "@nx/angular": "22.6.3",
    "@nx/cypress": "22.6.3",
    "@nx/eslint": "22.6.3",
    "@nx/eslint-plugin": "22.6.3",
    "@nx/jest": "22.6.3",
    "@nx/js": "22.6.3",
    "@nx/plugin": "22.6.3",
    "@nx/web": "22.6.3",
    "@nx/workspace": "22.6.3",
    "@openapitools/openapi-generator-cli": "^2.28.0",
    "@schematics/angular": "21.2.0",
    "@swc-node/register": "1.11.1",
    "@swc/core": "1.15.13",
    "@swc/helpers": "^0.5.19",
    "@types/jest": "30.0.0",
    "@types/js-cookie": "^3.0.6",
    "@types/jsoneditor": "^9.9.6",
    "@types/node": "25.3.1",
    "@typescript-eslint/eslint-plugin": "8.56.1",
    "@typescript-eslint/utils": "8.56.1",
    "angular-eslint": "21.2.0",
    "baseline-browser-mapping": "2.10.0",
    "command-line-args": "^6.0.1",
    "cypress": "15.11.0",
    "default-composer": "^0.6.0",
    "dpdm": "^4.0.1",
    "esbuild": "^0.27.3",
    "esbuild-plugin-copy": "^2.1.1",
    "esbuild-plugin-json-merge": "^0.1.0",
    "eslint": "9.39.2",
    "eslint-config-prettier": "10.1.8",
    "eslint-plugin-cypress": "6.1.0",
    "eslint-plugin-import": "~2.32.0",
    "eslint-plugin-json": "^4.0.1",
    "eslint-plugin-prettier": "^5.5.5",
    "eslint-plugin-sonarjs": "^4.0.0",
    "eslint-plugin-unused-imports": "^4.4.1",
    "globals": "^17.4.0",
    "husky": "^9.1.7",
    "jasmine-core": "6.1.0",
    "jasmine-spec-reporter": "7.0.0",
    "jest": "30.2.0",
    "jest-canvas-mock": "^2.5.2",
    "jest-environment-jsdom": "30.2.0",
    "jest-fail-on-console": "^3.3.4",
    "jest-jasmine2": "30.2.0",
    "jest-junit": "^16.0.0",
    "jest-preset-angular": "16.1.1",
    "jest-sonar-reporter": "^2.0.0",
    "jest-util": "30.2.0",
    "jsonc-eslint-parser": "^3.1.0",
    "lint-staged": "^16.3.1",
    "mockdate": "^3.0.5",
    "ng-mocks": "^14.15.1",
    "ng-packagr": "21.2.0",
    "nx": "22.6.3",
    "object-code": "^2.0.0",
    "prettier": "^3.8.1",
    "selenium-webdriver": "^4.41.0",
    "sonar-scanner": "^3.1.0",
    "ts-jest": "29.4.6",
    "ts-node": "10.9.2",
    "typescript": "5.9.3",
    "typescript-eslint": "8.56.1",
    "@ng-web-apis/common": "^5.1.0"
  },
  "jestSonar": {
    "reportPath": "target/test-results/jest",
    "reportFile": "TESTS-results-sonar.xml"
  }
}
